"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getQueryParam_1 = require("./getQueryParam");
var BEHAVIOUR_REGEX = /^(iosclient|nonavclient)$/;
var BEHAVIOUR_SESSIONVAR = 's_behaviour';
exports.shouldRenderUhf = function () {
    var queryBehaviour = getQueryParam_1.getQueryParam('behaviour');
    if (typeof queryBehaviour !== 'string') {
        queryBehaviour = queryBehaviour[0];
    }
    if (queryBehaviour.match(BEHAVIOUR_REGEX)) {
        window.sessionStorage.setItem(BEHAVIOUR_SESSIONVAR, queryBehaviour);
        return false;
    }
    var cookieBehaviour = window.sessionStorage.getItem(BEHAVIOUR_SESSIONVAR) || '';
    return !cookieBehaviour.match(BEHAVIOUR_REGEX);
};
//# sourceMappingURL=shouldRenderUhf.js.map